<template>
  <div id="transaction-invoices">
    <h2 class="title">MOVIMIENTOS FACTURABLES</h2>
    <p>
      Selecciona los movimientos a facturar, tomando en cuenta que solo se pueden facturar
      movimientos conjuntos con el mismo tipo de pago.
    </p>
    <div class="flex regimes">
      <label>Regimen Fiscal</label>
      <select v-model="selectedRegime">
        <option value="0" disabled>Seleccione el regimen fiscal</option>
        <option
          v-for="state in fiscalRegimes"
          :key="state.sat_id"
          :value="state.sat_id"
        >
          {{ state.description }}
        </option>
      </select>
    </div>
    <div class="flex zipcode">
      <label>Código Postal</label>
      <input v-model="selectedZipCode" type="text" maxlength="10" autocomplete="off" placeholder="Código postal">
    </div>
    <button @click="onSubmit" class="btn" :disabled="!canInvoice">Facturar</button>
    <component :is="tableHeaderComponent" />
    <div class="data-table">
      <component
        v-for="sale in invoiceableSales"
        :is="tableRowComponent"
        :key="sale.id"
        :sale="sale"
      />
    </div>
    <InformationModal
      @confirm="false"
      :active="showLoadingModal"
      title="Atención"
    >
      <template #content>
        Estamos generando su factura, esto puede tardar un minuto, por favor espere
      </template>
    </InformationModal>
    <InformationModal
      @confirm="removeInvoiceWarning"
      :active="invoiceWarning"
      title="Lo sentimos"
    >
      <template #content>
        Ha ocurrido un error al generar su factura, por favor intente mas tarde.
      </template>
    </InformationModal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import InformationModal from '@/components/InformationModal'
import TableHeader from '@/components/CreateInvoices/TableHeader'
import TableHeaderCE from '@/components/CreateInvoices/TableHeaderCE'
import TableRow from '@/components/CreateInvoices/TableRow'
import TableRowCE from '@/components/CreateInvoices/TableRowCE'

export default {
  name: 'InvoiceableSales',
  components: {
    InformationModal,
    TableHeader,
    TableHeaderCE,
    TableRow,
    TableRowCE
  },
  data () {
    return {
      showLoadingModal: false
    }
  },
  computed: {
    ...mapState('invoiceableSales', [
      'selectedSales'
    ]),
    ...mapGetters('invoiceableSales', [
      'invoiceableSales',
      'fiscalRegimes',
      'canInvoice',
      'invoiceWarning'
    ]),
    ...mapGetters('invoices', [
      'invoiceCreated'
    ]),
    ...mapGetters('user', [
      'userIsCompanyType'
    ]),
    tableHeaderComponent () {
      if (this.userIsCompanyType) {
        return 'TableHeaderCE'
      }

      return 'TableHeader'
    },
    tableRowComponent () {
      if (this.userIsCompanyType) {
        return 'TableRowCE'
      }

      return 'TableRow'
    },
    selectedRegime: {
      get () { return this.$store.state.invoiceableSales.selectedRegime },
      set (value) { this.updateSelectedRegime(value) }
    },
    selectedZipCode: {
      get () { return this.$store.state.invoiceableSales.selectedZipCode },
      set (value) { this.updateSelectedZipcode(value) }
    }
  },
  watch: {
    invoiceCreated (val) {
      if (val) {
        this.clearInvoiceFlag()
        this.$router.push('/created-invoice')
      }
    },
    invoiceWarning (val) {
      if (val) {
        this.showLoadingModal = false
      }
    }
  },
  beforeMount () {
    this.getSales()
  },
  methods: {
    ...mapActions('invoiceableSales', [
      'getSales',
      'removeInvoiceWarning',
      'updateSelectedRegime',
      'updateSelectedZipcode'
    ]),
    ...mapActions('invoices', [
      'createInvoice',
      'clearInvoiceFlag'
    ]),
    onSubmit (event) {
      if (this.selectedSales.size > 0) {
        this.showLoadingModal = true

        this.createInvoice()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#transaction-invoices {
  margin: 1rem 2rem;
  text-align: start;
}

.title {
  color: $grey;
}

.data-table {
  background-color: $white;
  border-radius: 20px;
  width: 100%;
  max-height: 50vh;
  overflow-y: scroll;
}
.btn {
  font-size: 1.2rem;
  background-color: $red;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.5em 1.5em;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }
  &:disabled {
    background-color: lightgray;
  }
}
.regimes {
  padding-bottom: 1em;
  label {
    padding-right: 1em;
  }
}
@media screen and (max-width: 60rem) {
  h2 {
    font-size: 1.25rem;
  }

}
</style>
